import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RoutesWeb } from "./shared/interfaces/routes";
import Forbidden from "./shared/modules/error/page";
import Home from "./shared/pages";
import { AppTheme } from "./shared/theme/AppTheme";
import { Providers } from "./stateManagement/provider";
import "./styles/globalstyles.scss";
import DetailsLocation from "./tecnica/pages/dashboard/listLocation/components/details/DetailsLocation";
import DashboardWellWhisper from "./tecnica/pages/dashboard/page";
import InfoTask from "./tecnica/pages/dashboard/planing/components/info_task/info";
import { ConsolidateCards } from "./tecnica/pages/dashboard/reports/cards_bm";
import ReportDaily from "./tecnica/pages/dashboard/reports/close_daily/index";
import { ConsolidateBCP } from "./tecnica/pages/dashboard/reports/consolidade_bcp";
import { ConsolidateBM } from "./tecnica/pages/dashboard/reports/consolidate_bm";
import { DailySummaryModule } from "./tecnica/pages/dashboard/reports/dailySummary";
import HistoryOfActivities from "./tecnica/pages/history/page";
import UploadTaskLand from "./tecnica/pages/upload/monitoreo/page";
import UploadOptions from "./tecnica/pages/upload/page";
import UploadModuleV2 from "./tecnica/pages/upload/monitoreov2/page";
import { UploadWellFiles } from "./tecnica/pages/upload/well_files/page";
import { AnalystSummary } from "./tecnica/pages/dashboard/reports/analyst_summary";
import { OperationsSummaryCards } from "./tecnica/pages/dashboard/operations/operationsSummaryCards";
import { PicturesAgileView } from "./tecnica/pages/dashboard/operations/picturesAgileView";
import { ListOfOptimizationsOptions } from "./tecnica/pages/dashboard/operations/listOfOptimizationsOptions";
import { BackupMobile } from "./tecnica/modules/backupMobile";
import { BackUpMobileFiles } from "./tecnica/pages/upload/backupMobile";
import { DynCardsUploadPage } from "./tecnica/pages/upload/dynCards/page";
import { VehicleOverview } from "./tecnica/pages/dashboard/reports/vehicle_overview";
import { PhysicalCheck } from "./tecnica/pages/dashboard/reports/physical_check";
// Determine the basename dynamically
const isLocalhost = window.location.hostname === "localhost";
const basename = isLocalhost ? "" : "/";

function App() {
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Providers>
                <ToastContainer />
                <AppTheme>
                    <Router basename={basename}>
                        <Routes>
                            <Route
                                path={RoutesWeb.shared.home}
                                element={<Home />}
                            />
                            {/* Gerencia Tecnica y Operaciones */}
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .history
                                }
                                element={<HistoryOfActivities />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .dashboard
                                }
                                element={<DashboardWellWhisper />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .reports_close_daily
                                }
                                element={<ReportDaily />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .reports_consolidate_bm
                                }
                                element={<ConsolidateBM />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .reports_overview
                                }
                                element={<VehicleOverview />}
                            />

                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .reports_consolidate_bcp
                                }
                                element={<ConsolidateBCP />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .reports_daily_summary
                                }
                                element={<DailySummaryModule />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .reports_consolidate_cards_bm
                                }
                                element={<ConsolidateCards />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .reports_physical_check
                                }
                                element={<PhysicalCheck />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .upload
                                }
                                element={<UploadOptions />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .upload_monitoreo
                                }
                                element={<UploadTaskLand />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .upload_monitoreoV2
                                }
                                element={<UploadModuleV2 />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .upload_well_files
                                }
                                element={<UploadWellFiles />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones.task
                                }
                                element={<InfoTask />}
                            />

                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .details_location
                                }
                                element={<DetailsLocation />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .analyst_summary
                                }
                                element={<AnalystSummary />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .operations_summary_cards
                                }
                                element={<OperationsSummaryCards />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .pictures_agile_view
                                }
                                element={<PicturesAgileView />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .upload_backup_mobile
                                }
                                element={<BackUpMobileFiles />}
                            />
                            <Route
                                path={
                                    RoutesWeb.gerencia_tecnica_operaciones
                                        .upload_dyn_cards
                                }
                                element={<DynCardsUploadPage />}
                            />
                            <Route path="/403" element={<Forbidden />} />
                            <Route path="*" element={<Forbidden />} />
                        </Routes>
                    </Router>
                </AppTheme>
            </Providers>
        </LocalizationProvider>
    );
}

export default App;
